var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 6c0-.345.28-.625.625-.625h18a.625.625 0 1 1 0 1.25H3A.625.625 0 0 1 2.375 6Zm0 6c0-.345.28-.625.625-.625h15a.625.625 0 1 1 0 1.25H3A.625.625 0 0 1 2.375 12Zm0 6c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H3A.625.625 0 0 1 2.375 18Z",
    fill: "currentColor"
  })));
};
export default SvgList;